<template>
    <div id="formAgreementInput" class="col-lg-6 offset-lg-3 col-md-10 col-sm-12">
        <div v-for="agreement in agreementInputs" class="row align-items-center mb-3">
            <input v-bind:class="'form-control col-1 d-inline-block ' + (hasError(agreement.id) ? 'error-input' : '')" type="checkbox" :value="agreement.id" :id="agreement.id" @input="updateValue($event.target.value)">
            <label :for="agreement.id" class="mb-0 col-11">
                <h6 class="mb-0"><span class="text-danger" v-if="agreement.required" v-html="'* '"></span>
                    <span v-html="agreement.content"/></h6>
            </label>
            <div class="error" v-if="hasError(agreement.id)">
                <br/>
                <ul>
                    <li>Prosimy zaznaczyć wymaganą zgodę</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['name', 'errorMessages', 'agreementInputs'],

    methods: {
        updateValue(value) {
            if(Array.isArray(this.value) && value in this.value) {
                if(this.value[value] === true) {
                    this.value[value] = false;
                } else {
                    this.value[value] = true;
                }
            } else {
                if(!Array.isArray(this.value)) {
                    this.value = [];
                }
                this.value[value] = true;
            }

            this.$emit('input', this.value);

            var key = 'agreements.' + value;
            if(this.errorMessages !== null && key in this.errorMessages) {
                this.errorMessages[key] = null;
            }
            if(this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        },
        hasError(id) {
            var key = 'agreements.' + id;
            if(this.errorMessages !== null && key in this.errorMessages) {
                return true;
            }

            return false;
        }
    },
    data() {
        return {
            value: [],
        };
    },
    watch: {
        errorMessages: function (newValue, oldValue) {
            this.$forceUpdate();
        }
    }

}
</script>
